'use client';

import
  Link
from 'next/link';

import
  dynamic
from 'next/dynamic';

import {
  useScrollReveal
} from '@/app/hooks/use-scroll-reveal';

const LottiePlayer = dynamic(() => import('@repo/ui/lottie-player'), {
  ssr: false
});

interface ServiceCardProps {
  title: string
  description: string
  href: string
  animation: string
}

export default function ServiceCard({
  title, description, href, animation
}: ServiceCardProps) {

  const {
    ref, isVisible
  } = useScrollReveal<HTMLDivElement>();

  return (
    <div
      ref={ref}
      className={`group flex flex-col items-center text-center p-8 rounded-2xl border border-gray-100 dark:border-gray-800 hover:shadow-lg transition-all duration-500 ${ isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4' }`}
    >
      <div className="w-40 h-40 mb-2">
        {isVisible && <LottiePlayer animationPath={animation} className="w-full h-full" />}
      </div>

      <h3 className="text-lg font-bold text-[#0a1628] dark:text-white mb-3">{title}</h3>
      <p className="text-gray-500 dark:text-gray-400 text-sm leading-relaxed flex-1">{description}</p>

      <Link
        href={href}
        className="mt-6 inline-flex items-center gap-2 text-sm font-semibold transition-all duration-200 hover:gap-3 active:scale-[0.97]"
        style={{
          color: 'rgba(1,158,250,1)'
        }}
      >
        Learn more
        <span className="sr-only">
          {' '}
          about
          {' '}
          {title}
        </span>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className="w-3.5 h-3.5 fill-current">
          <path d="M438.6 278.6l-160 160C272.4 444.9 264.2 448 256 448s-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L338.8 288H32C14.33 288 .0016 273.7 .0016 256S14.33 224 32 224h306.8l-105.4-105.4c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160C451.1 245.9 451.1 266.1 438.6 278.6z" />
        </svg>
      </Link>
    </div>
  );
}
